<bp-footer-mock-links></bp-footer-mock-links>

<small class="version">Powered by Bridgerpay <bp-app-version></bp-app-version></small>
